import { StyleProp, View, ViewStyle } from "react-native";
import search_wheel from "src/assets/images/search/search_wheel.png";
import native from "src/constants/native";
import { paddingSmallSpacer, paddingSpacer, paddingXL } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";

const aspectRatio = 256 / 192;
const HasKeyboardAdjustment = native;
const SearchNoResults = ({ style }: { style?: StyleProp<ViewStyle> }) => {
	return (
		<View
			style={[
				{
					flex: 1,
					alignItems: "center",
					paddingTop: HasKeyboardAdjustment ? paddingSmallSpacer : 100,
				},
				style,
			]}
		>
			<Image
				alt="Empty Search Results"
				src={search_wheel}
				dim={{
					aspectRatio,
					height: 200,
				}}
			/>
			<Text
				style={{
					marginTop: paddingXL,
					marginHorizontal: paddingSpacer,
					textAlign: "center",
				}}
			>
				No matches for your search
			</Text>
		</View>
	);
};
export default SearchNoResults;
